import curl from './curd'
const add = (tableName, writeObject) => {
    try {
        curl.insert(tableName, writeObject)
    } catch (err){
        console.error('zskk db controller add error:', err)
    }
}

const count = (tableName, where, cb) => {
    try {
        curl.count(tableName, where, cb)
    } catch (err){
        console.error('zskk db controller add error:', err)
    }
}

const queryAll = (tableName, cb) => {
    try {
        curl.queryAll(tableName, cb)
    } catch (err){
        console.error('zskk db controller queryAll error:', err)
    }
}

const clear = tableName => {
    try {
        curl.clear(tableName)
    } catch (err){
        console.error('zskk db controller clear error:', err)
    }
}
const ZskkDbController = {add, queryAll, clear, count}
export default ZskkDbController